<template>
  <div class='signatory-query'>
    <div class='signatory-query__inner'>
      <el-autocomplete
        class='signatory-query__input'
        v-model='value'
        v-bind='$attrs'
        v-on='$listeners'
        :fetch-suggestions='querySearchAsync'
        :popper-append-to-body='true'
        placeholder='请输入签约人'
        @select='handleSelect'
        @change='changeValue'
        clearable></el-autocomplete>
      <el-link v-if='showSet' @click='setPage' v-hasAuthority="'sign_signatory_setting'">
        <svg-icon :title='`来源部门:【${signatory}】,点击修改来源`' icon-class='qianyue' class='iconName'></svg-icon>
      </el-link>
    </div>

    <el-dialog
      title='请选择签约数据来源部门'
      :visible.sync='dialogVisible'
      width='30%'
      :before-close='handleConfirm'>
      <el-row>
        <el-col :span='1.5'>
          部门中选择：
        </el-col>
        <el-col :span='1.5'>
          <CompanySelect :allow-create='true' :multiple='true' :valueType="'name'" style='display: inline-block'
                         @handleSelect='handleChange' />
        </el-col>

      </el-row>
      <br>
      <el-row>
        <el-col :span='1.5'>
          自定义输入(使用 "," 作为分隔号)：
        </el-col>
        <el-col :span='1.5'>
          <el-input v-model='inputValue' @change='inputInit' style='width: 200px' size='mini'></el-input>
        </el-col>

      </el-row>
      <br>
      <el-tag
        v-for='tag in signatory'
        :key='tag'
        :disable-transitions='false'
        closable
        style='margin-right: 10px'
        type='success'
        @close='handleClose(tag)'>
        {{ tag }}
      </el-tag>

      <span slot='footer' class='dialog-footer'>
        <el-button @click='dialogVisible = false'>取 消</el-button>
        <el-button type='primary' @click='saveDiag'>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'SignatoryQuery',
  data() {
    return {
      dataList: [],
      value: '',
      signatoryLoading: null,
      signatory: [],
      dialogVisible: false,
      inputValue: ''
    }
  },
  watch: {
    name(val) {
      this.value = val
    }

  },
  // computed: {
  //   value() {
  //     return this.name
  //   }
  // },
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    },
    showSet: {
      type: Boolean,
      default() {
        return false
      }
    }

  },
  methods: {
    inputInit() {
      if (this.inputValue != '') {
        const data = this.inputValue.split(',')
        this.signatory = [...this.signatory, ..._.difference(data, this.signatory)]
      }
    },
    handleClose(tag) {
      this.signatory.splice(this.signatory.indexOf(tag), 1)
    },
    async saveDiag() {
      const id = await this.$api.saveSettingSiteInfo({ signatory: this.signatory.toString() })
      if (id) {
        this.$notify.success('保存成功！')
        this.dialogVisible = false

      }
    },
    handleConfirm() {
      this.dialogVisible = false
      this.initSettingSiteForm()
    },

    handleChange(selectArr) {
      this.signatory = selectArr
      return selectArr
    },

    async initSettingSiteForm() {
      // 获取站点分类列表
      const data = await this.$api.getSignatorySetting()
      this.signatory = data.value.split(',')
    },
    setPage() {
      this.dialogVisible = true
    },
    async initSignatoryOption() {
      if (this.signatoryLoading) {
        return this.signatoryLoading
      }

      this.signatoryLoading = this.$api.getSignInfoSignatoryList().then(({ list = [] }) => {
        this.dataList = []
        list.forEach((item) => {
          this.dataList.push({ value: `${item.name}`, label: item.name })
        })
      }).finally(() => {
        this.signatoryLoading = null
      })

      return this.signatoryLoading
    },
    querySearchAsync(queryString, cb) {
      const showResults = () => {
        cb(this.filterSignatoryList(queryString))
      }

      if (this.dataList.length > 0) {
        showResults()
        return
      }

      this.initSignatoryOption().then(showResults).catch(() => {
        cb([])
      })
    },
    filterSignatoryList(queryString) {
      const dataList = Array.isArray(this.dataList) ? this.dataList : []
      return queryString ? dataList.filter(this.createStateFilter(queryString)) : dataList
    },
    createStateFilter(queryString) {
      const keyword = String(queryString || '').toLowerCase()
      return (state) => {
        return String(state.value || '').toLowerCase().indexOf(keyword) === 0
      }
    },
    handleSelect(item) {
      this.$emit('handleSelect', item)
    },
    changeValue() {
      this.$emit('changeValue', this.value)
    }
  },
  mounted() {
    this.initSignatoryOption()
    this.value = this.name
    this.initSettingSiteForm()
  }
}
</script>

<style scoped>
.signatory-query {
  display: inline-block;
}

.signatory-query__inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  width: 100%;
}

.signatory-query__input {
  flex: 1;
  min-width: 0;
}

.signatory-query__input ::v-deep .el-input {
  width: 100%;
}

.iconName {
  display: inline-block;
  color: #ff3176;
  cursor: pointer;
}


</style>
